export const TOPBAR_NEXT_INTERNAL_KEY = '__TOPBAR__'
